import { MantineColor, Text } from '@mantine/core';

export default ({ color, text }: { text: string; color?: MantineColor }) => (
  <Text mt={3} color={color ? color : ''} className="break-words" style={{ wordBreak: 'break-word' }}>
    {text}
  </Text>
);
